import { MenuItem, LocationInfo } from "../lib/index";
import { IMAGES } from "../assets/images";

export const restaurantInfo = {
  name: "Bagus Chicken Dakgalbi",
  tagline: "Authentic Korean Flavors, Crafted with Passion",
  description:
    "Bagus Chicken Dakgalbi brings the heart of Seoul to Sunway Geo Mall. As an owner-operated establishment, we pride ourselves on hands-on leadership and authentic recipes. We specialize in sizzling Dakgalbi and crispy Korean Fried Chicken, served in a modern, pink-themed atmosphere that's as friendly as our service.",
  values: [
    {
      title: "Authentic Flavors",
      description: "Traditional Korean recipes passed down and perfected for the modern palate.",
    },
    {
      title: "Specialized Cuisine",
      description: "We focus on what we do best: Dakgalbi and Korean Fried Chicken.",
    },
    {
      title: "Reasonable Pricing",
      description: "Premium quality Korean dining that doesn't break the bank.",
    },
    {
      title: "Owner-Operated",
      description: "Hands-on leadership ensuring every dish meets our high standards.",
    },
  ],
};

export const locationInfo: LocationInfo = {
  mallName: "Sunway Geo Mall",
  address: "Jalan Lagoon Selatan, Sunway South Quay, Bandar Sunway, 47500 Subang Jaya, Selangor",
  unitNumber: "B-01-06",
  phone: "+60 3-5611 9988",
  whatsapp: "+60 12-345 6789",
  operatingHours: {
    weekdays: "11:30 AM - 9:30 PM",
    weekends: "11:30 AM - 10:30 PM",
  },
  grabLink: "https://food.grab.com/my/en/restaurant/bagus-chicken-dakgalbi-sunway-geo-delivery/",
  googleMapsUrl: "https://maps.app.goo.gl/SunwayGeoMall",
  landmark: "Opposite Sunway Medical Centre",
};

export const menuItems: MenuItem[] = [
  {
    id: "dakgalbi-original",
    name: "Signature Spicy Dakgalbi",
    description: "Stir-fried marinated chicken in a gochujang-based sauce with cabbage, sweet potato, and tteokbokki.",
    price: 26.5,
    category: "Signature Dakgalbi",
    image: IMAGES.IMAGE_29,
    isSpicy: true,
    isBestSeller: true,
    portionSize: "2-3 Pax",
  },
  {
    id: "kfc-original",
    name: "Original Crispy Chicken",
    description: "Double-fried to perfection for that ultimate Korean crunch. Lightly seasoned and juicy.",
    price: 50.0,
    category: "Korean Fried Chicken",
    image: IMAGES.KOREAN_CHICKEN_1,
    isBestSeller: true,
    portionSize: "6-8 Pieces",
  },
];
